import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'w-full h-9 rounded-lg border border-ink-300 bg-white px-3 text-sm text-ink-900 placeholder:text-ink-400',
        'focus:outline-none focus:ring-2 focus:ring-brand-400 focus:border-brand-500',
        'disabled:bg-ink-50 disabled:text-ink-400',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
